const GetSettings = (key: string, defaultValue: any) => {
  let d: any = localStorage.getItem("settings");
  if (d) {
    d = JSON.parse(d);
  } else {
    d = {};
  }
  return d[key] !== undefined ? d[key] : defaultValue;
};

const SetSettings = (key: string, value: any) => {
  let d: any = localStorage.getItem("settings");
  if (d) {
    d = JSON.parse(d);
  } else {
    d = {};
  }
  d[key] = value;
  localStorage.setItem("settings", JSON.stringify(d));
};

const SettingsUtil = {
  GetSettings,
  SetSettings,
};

export default SettingsUtil;
